
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class Adv05ItemExDTsDialog extends Serenity.EntityDialog<Adv05ItemExDTsRow, any> {
        protected getFormKey() { return Adv05ItemExDTsForm.formKey; }
        protected getIdProperty() { return Adv05ItemExDTsRow.idProperty; }
        protected getLocalTextPrefix() { return Adv05ItemExDTsRow.localTextPrefix; }
        protected getNameProperty() { return Adv05ItemExDTsRow.nameProperty; }
        protected getService() { return Adv05ItemExDTsService.baseUrl; }
        protected getDeletePermission() { return Adv05ItemExDTsRow.deletePermission; }
        protected getInsertPermission() { return Adv05ItemExDTsRow.insertPermission; }
        protected getUpdatePermission() { return Adv05ItemExDTsRow.updatePermission; }

        protected form = new Adv05ItemExDTsForm(this.idPrefix);

    }
}